import { Device } from "@fairfleet/geotab";

export function devicesActiveDuring(devices: Device[], fromDate: Date): Device[] {
  return devices.filter(device => {
    const activeTo = device.activeTo;
    if (!activeTo) return true;
    return new Date(activeTo) >= fromDate;
  });
}
